<template>
    <div>
        <div v-if="notes.length != 0" class="card">
            <div class="card-body">
                <h5>Consignas transitorias pendientes</h5>
                <table class="table table-sm table-hover table-bordered table-striped">
                    <thead class="thead-orange">
                        <tr>
                            <th>Fecha</th>
                            <th>Anotación</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr v-if="!!notes.length" v-for="note in notes">
                            <td>{{ note.created_at | datetime }}</td>
                            <td>{{ note.content | elipsis(40) }} </td>
                            <td>  
                                <button class="btn btn-confirm" v-if="!isChecked(note.id)" @click="selectNote(note.id)"><i class="fa fa-check" aria-hidden="true"></i></button>
                                <button class="btn btn-danger" v-if="isChecked(note.id)" @click="deselectNote(note.id)"><i class="fa fa-ban" aria-hidden="true"></i></button>
                                <button class="btn btn-primary" @click="seeMore(note)"><i class="fa fa-search-plus" aria-hidden="true"></i></button>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-pop-up id="view-more-pending-note" title="Consigna transitoria">
                <div slot="body">
                    <div class="row">
                        <div class="col-12 col-sm">
                            <div>
                                <h5>Fecha</h5> 
                                <label>{{minuta.date | datetime}}</label>
                            </div>
                        </div> 
                        <br>
                    </div> 
                    <br>       
                    <h5 style="text-align:center"><label for="anotation">Anotación</label></h5>
                    <textarea type="text" id="anotation" class="form-control" disabled="true" cols="60" rows="8" v-model="minuta.anotation"></textarea>
                </div>   
        </app-pop-up>
    </div>
    
</template>
<script>
import PopUp from '../../../../UI/Controls/PopUp/PopUp.vue';
export default {
    components:{
        appPopUp: PopUp,
    },
    props:{
        notebooks: {
            type: Array,
            default: () => []
        }

    },
    data(){
        return {
            notes: [],
            minuta: {
                date: '',
                anotation: ''
            },
            selectedNotes: []

        }
    },
    watch: {
        selectedNotes(){
            this.$emit('input', this.selectedNotes);
        }
    },
    methods: {
        isChecked(id){
            return this.selectedNotes.includes(id);
        },
        selectNote(note){
            this.selectedNotes.push(note);
        },
        deselectNote(note){
            const index = this.selectedNotes.findIndex(item => item === note);
            this.selectedNotes.splice(index, 1);
        },
        seeMore(note){
                this.minuta.anotation = note.content;
                this.minuta.date = note.created_at;

                this.$bus.$emit('view-more-pending-note.open');
            }
    },
    created(){
        this.notes = this.notebooks.filter(item => !item.completed);
        
        //this.notes.filter(item => this.notes.map(note => note.completed == null));
    }

}
</script>
